import React from 'react';
import { LegendCard } from './LegendCard';

// matplotlib gist_earth sampled at 5 stops — dark navy through teal/green
// to olive/tan to near-white. Kept in sync with AgbMapLegend so both Flux
// gist_earth rasters read with the same ramp.
const GIST_EARTH_CSS_GRADIENT =
  'linear-gradient(to right, #000000 0%, #1d5e56 25%, #65992d 50%, #cab155 75%, #fdfbfb 100%)';

interface SoilCarbonMapLegendProps {
  // Raw Flux colorscalerange in Mg C/ha — passes through to the gradient
  // ticks, so the legend numerically matches what the server renders.
  rescale: [number, number];
  // Drives the legend title; soil carbon serves two sibling datasets with
  // materially different value ranges, so surfacing the depth is load-bearing.
  depth: 30 | 100;
}

export const SoilCarbonMapLegend: React.FC<SoilCarbonMapLegendProps> = ({ rescale, depth }) => {
  const [vmin, vmax] = rescale;
  return (
    <LegendCard title={<>Soil carbon (0&ndash;{depth}&nbsp;cm)</>} className="w-[220px]">
      <div
        className="h-3 w-full rounded-sm"
        style={{ background: GIST_EARTH_CSS_GRADIENT }}
      />
      <div className="flex items-center justify-between text-[10px] font-roboto-mono text-neutral-400 mt-1">
        <span>{vmin} Mg C/ha</span>
        <span>{vmax} Mg C/ha</span>
      </div>
    </LegendCard>
  );
};
